export const fitEntityLabelFontSize = (
  name: string,
  availableWidth: number,
  minFontSize: number,
  maxFontSize: number,
): number => {
  const estimated = availableWidth / Math.max(1, name.length * 0.6)
  return Math.max(minFontSize, Math.min(maxFontSize, estimated))
}
